<template>
  <div>
      <NavBar/>
      <transition name="fade">
             <router-view name="dialog"></router-view>
      <router-view></router-view>
      </transition>
 
     
  </div>
</template>
<script>
import NavBar from './components/nav.vue'
  export default {
      components:{
      NavBar 
    },
    created() {
      this.fetchPhotos();
      this.fetchPhotographers();
      this.$store.dispatch('gallery/fetchTodayPhoto');
      this.$store.dispatch('fetchPicData');
    },
    methods: {
      fetchPhotos() {
        var page = 1;
        this.$store.dispatch('gallery/fetchgallery', {
          page,
          clear:true
        });
      },
      fetchPhotographers() {
        var page = 1;
        this.$store.dispatch('gallery/fetchPhotographers', {
          page,
        });
      }
    },
     mounted() {
         
            let bodyElement = document.body;
            bodyElement.classList.add("app-background");
            // check for active theme
            let htmlElement = document.documentElement;
            let theme = localStorage.getItem("theme");
            let direction = localStorage.getItem("direction");
          
            htmlElement.setAttribute('theme', 'dark')
            this.$darkmode = true

             
            this.$i18n.locale =this.$locale;
            htmlElement.setAttribute('locale',this.$locale)
             if (direction === 'rtl') {
                htmlElement.setAttribute('direction', 'rtl')
                this.$rtl = true
               
            } else {
                htmlElement.setAttribute('direction', 'rtl');
                this.$rtl = false
              
            }

             if (theme === 'light') {
                  htmlElement.setAttribute('theme', 'light');
                this.$darkmode = false
            } 
             
            if (theme === 'dark') {
                htmlElement.setAttribute('theme', 'dark')
                this.$darkmode = true
            } 
             if (this.$store.state.options.moharam) {
              htmlElement.setAttribute('theme', 'moharam')
              this.$darkmode = true
            }
            // this.$store.dispatch('settings/update',{
            //   dark:this.$darkmode
            // });
    },
     computed:{
      isLoggedIn : function(){ return this.$store.getters['auth/isLoggedIn']},
      authStatus : function(){ return this.$store.getters['auth/authStatus']},
      userInfo : function(){ return this.$store.state.auth.userInfo}
  },
    watch: {
      $darkmode: function () {
        // add/remove class to/from html tag
        let htmlElement = document.documentElement;
        if (this.$darkmode) {
          localStorage.setItem("theme", 'dark');
          htmlElement.setAttribute('theme', 'dark');
        } else {
          localStorage.setItem("theme", 'light');
          htmlElement.setAttribute('theme', 'light');
        }

          if (this.$store.state.options.moharam) {
              htmlElement.setAttribute('theme', 'moharam')
              this.$darkmode = false
            }
        // this.$store.dispatch('settings/update',{
        //       dark:this.$darkmode
        //     });
      },
 
    },
  }
</script>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
</style>